export const useBclickId = () => {
  const getBclickIdFromUrl = (): string | null => {
    if (typeof window === 'undefined') return null
    const url = new URL(window.location.href)
    return url.searchParams.get('bclickId') || url.searchParams.get('sub2')
  }

  return {
    getBclickId: getBclickIdFromUrl,
  }
}
